import { CHAIN_ID } from '@derivation-tech/context';

import { IDappChainConfig } from '@/types/chain';
import { Chain } from 'viem';

function jsonFileMapping(chainId: CHAIN_ID): string | undefined {
  switch (chainId as number) {
    case CHAIN_ID.BASE:
      return 'base';
    case CHAIN_ID.GELATO:
      return 'gelato';
    case CHAIN_ID.ABC:
      return 'abc';
    case CHAIN_ID.MONADTESTNET:
      return 'monadTestnet';
    case CHAIN_ID.BLAST:
      return 'blast';
  }
}
const chainConfigJsons = import.meta.glob('./*.json', { eager: true, as: 'json' });

export function getDappChainConfig(chainId: CHAIN_ID, wagmiChain: Chain): IDappChainConfig {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const chainConfig = chainConfigJsons[`./${jsonFileMapping(chainId)}.json`] as IDappChainConfig;
  let config = chainConfig;

  if (chainConfig) {
    config = JSON.parse(JSON.stringify(chainConfig)) as IDappChainConfig;
    config.wagmiChain = wagmiChain;
  }
  return config;
}
